<template>
  <div class="seating" ref="trackingEl">
    <SectionHeader
      title="Seating Experiences"
      imgSrc="seating-experiences/seating-ex-titlebg.jpeg"
    />
    <div v-for="child in pageChildren" :key="child" class="carousel_container">
      <h2 class="row_header">{{ child.title }}</h2>
      <Carousel :childId="child.id" :subPage="true" />
    </div>
  </div>
</template>

<script>
import { reactive, toRefs, ref, computed, watchEffect } from "vue";
import { useStore } from "vuex";
import SectionHeader from "@/components/SectionHeader.vue";
import Carousel from "@/components/Carousel";
import { useIntersectionObserver } from "@vueuse/core";

export default {
  name: "SeatingExperiences",
  components: {
    SectionHeader,
    Carousel,
  },
  setup() {
    const store = useStore();
    const trackingEl = ref();

    // State
    const state = reactive({
      pageChildren: computed(() => store.getters["purl/getPageChildren"](3)),
    });

    setTimeout(() => {
      useIntersectionObserver(trackingEl, ([{ isIntersecting }], _) => {
        if (isIntersecting) {
          store.dispatch("purl/purlPageTracking", {
            sectionId: 3,
          });
        }
      });
    }, 2000);

    // watchEffect((abc) => console.log("state", abc.value));

    return { ...toRefs(state), trackingEl };
  },
};
</script>

<style lang="scss" scoped>
.carousel_container {
  margin-block: 50px;
  overflow: hidden;
}

.row_header {
  font-family: Formula1-Display-Bold;
  font-size: 33px;
  color: #00939b;
  text-align: center;
  line-height: 75px;
  font-weight: 500;
  padding-top: 3em;
  padding-bottom: 1em;
  text-transform: uppercase;
}
</style>
